import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import {
  DetailsOpenStatusByPartsName,
  DetailsOpenStatusByTravelerIdByPartsName,
} from '../../interface/checkin-passenger-input';
import {
  CheckinPassengerInputStore,
  selectCheckinPassengerInputState,
  updateCheckinPassengerInput,
} from '../../store/checkin-passenger-input';

@Injectable({
  providedIn: 'root',
})
export class CheckinPassengerInputStoreService {
  constructor(private _store: Store<CheckinPassengerInputStore>) {}

  /**
   * 搭乗者ごとのパーツごとのDetailsボタンの開閉状態を取得する
   * @param travelerId
   * @param partsName
   * @returns true: 開く / false: 閉じる
   */
  getDetailsOpenStatusByTravelerIdByPartsName(travelerId: string, partsName: string): boolean | undefined {
    let isOpen: boolean | undefined = undefined;

    this._store
      .pipe(select(selectCheckinPassengerInputState), take(1))
      .subscribe((state) => (isOpen = state.model?.[travelerId]?.[partsName]?.isOpen));

    return isOpen;
  }

  /**
   * 搭乗者ごとのパーツごとのDetailsボタンの開閉状態を更新する
   * @param travelerId
   * @param partsName
   * @param isOpen
   */
  updateDetailsOpenStatusByTravelerIdByPartsName(travelerId: string, partsName: string, isOpen: boolean): void {
    const partState = { ...(this.getDetailsOpenStatusByTravelerId(travelerId) || {}) };
    partState[partsName] = { isOpen: isOpen };

    const updateState: DetailsOpenStatusByTravelerIdByPartsName = {};
    updateState[travelerId] = partState;

    this._store.dispatch(updateCheckinPassengerInput({ model: updateState }));
  }

  /**
   * 搭乗者ごとのDetailsボタンの開閉状態を取得する
   * @param travelerId
   * @returns 搭乗者ごとのDetailsボタンの開閉状態
   */
  private getDetailsOpenStatusByTravelerId(travelerId: string): DetailsOpenStatusByPartsName | undefined {
    let travelerState: DetailsOpenStatusByPartsName | undefined = undefined;

    this._store
      .pipe(select(selectCheckinPassengerInputState), take(1))
      .subscribe((state) => (travelerState = state.model?.[travelerId]));

    return travelerState;
  }
}
